import React, { useEffect, useState, useRef } from "react"
import SunburstChart from "sunburst-chart"
import fromKapsule from "react-kapsule"
import NoData from "components/Common/NoData";

const ReactSunburst = fromKapsule(SunburstChart, {
  methodNames: ["focusNode"]
})

const getColorByDepth = (depth) => {
  switch (depth) {
    case 0:
      return '#228B22'; // Forest Green for root
    case 1:
      return '#32CD32'; // Lime Green for first level
    case 2:
      return '#3CB371'; // Medium Sea Green for second level
    case 3:
      return '#66CDAA'; // Medium Aquamarine for third level
    case 4:
      return '#98FB98'; // Pale Green for fourth level
    case 5:
      return '#7FFF00'; // Chartreuse for fifth level
    default:
      return '#556B2F'; // Dark Olive Green for deeper levels or undefined
  }
};

const Chart = ({ data }) => {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 550, height: 550 });
  
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const newSize = Math.min(containerWidth, 550); // Cap at 550px
        setDimensions({
          width: newSize,
          height: newSize
        });
      }
    };
    
    // Initial dimensions
    updateDimensions();
    
    // Add resize listener
    window.addEventListener('resize', updateDimensions);
    
    // Cleanup
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  // Check if data is the "No data available" message
  const isNoData = data?.message === "No data available";
  
  if (isNoData) {
    return <NoData/>;
  }
  
  return (
    <div ref={containerRef} className="w-full max-w-[550px]">
      <ReactSunburst
        width={dimensions.width}
        height={dimensions.height}
        excludeRoot
        label="name"
        size="size"
        color={(d, node) => getColorByDepth(node?.depth)}
        centerRadius={0.3}
        radiusScaleExponent={0.7}
        tooltipContent={(d, node) => `Policies: ${node.data.size}`}
        data={data}
      />
    </div>
  )
}

export default Chart